import moment from 'moment';

import Constants from '@/common/constants';

import { getCurrentYear } from './year';

/**
 * Получение даты в русском формате
 */
export const getRuFormattedDate = (date: moment.MomentInput, format: string) =>
  date != null ? moment(date).locale('ru').format(format) : '';

/**
 * Получение даты в формате D MMMM YYYY
 */
export const getRuCurrentDateWithFullMonth = () => {
  return getRuFormattedDate(Date.now(), Constants.DATE_FORMATS.DD_MMMM_YYYY);
};

/**
 * Получение даты в формате DD.MM.YYYY
 */
export const getRuDate = (date: moment.MomentInput) => {
  return getRuFormattedDate(date, Constants.DATE_FORMATS['DD.MM.YYYY']);
};

/**
 * Получение текущей даты в формате DD.MM.YYYY
 */
export const getRuCurrentDate = () => {
  return getRuDate(Date.now());
};

/**
 * Получение текущей даты в формате YYYY-MM-DD
 */
export const getCurrentDate = () => {
  return moment().format(Constants.DATE_FORMATS['YYYY-MM-DD']);
};

/**
 * Получение даты начала текущего года в формате DD.MM.YYYY
 */
export const getRuStartCurrentDate = () => {
  return getRuDate(moment().startOf('year'));
};

/**
 * Получение даты последнего года в формате DD.MM.YYYY
 */
export const getRuLastYearDate = () => {
  const date = new Date();
  return getRuDate(date.setFullYear(date.getFullYear() - 1));
};

/**
 * Получение даты формате с словом месяца
 */
export const getRuFormattedDateWithMonthWord = (date: moment.MomentInput) =>
  getRuFormattedDate(date, Constants.DATE_FORMATS.DD_MMMM_YYYY);

/**
 * Получение даты в формате с словом месяца для диапазона
 */
export const getRuFormattedRangeDateWithMonthWord = (startDate: string, endDate: string, isBreakLine = false) => {
  if (!startDate && !endDate) return '';

  const startDateObj = moment(startDate);
  const endDateObj = moment(endDate);

  if (startDateObj.isSame(endDateObj, 'day')) return getRuFormattedDateWithMonthWord(startDate);

  if (!endDate) return getRuFormattedDateWithMonthWord(startDate);

  return `${getRuFormattedDateWithMonthWord(startDate)} - ${isBreakLine ? '\n' : ''}${getRuFormattedDateWithMonthWord(
    endDate,
  )}`;
};

/**
 * Получение даты в формате DD.MM.yyyy HH:mm:ss
 */
export const getRuDateTime = (date: moment.MomentInput) => {
  return getRuFormattedDate(date, Constants.DATE_FORMATS['DD.MM.yyyy HH:mm:ss']);
};

/**
 * Получение даты начала года по году
 */
export const getDateWithStartYearByYear = (year: string) => {
  return moment(year, Constants.DATE_FORMATS.YYYY).startOf('year').format(Constants.DATE_FORMATS['YYYY-MM-DD']);
};

/**
 * Получение даты конца года по году
 */
export const getDateWithEndYearByYear = (year: string) => {
  return moment(year, Constants.DATE_FORMATS.YYYY).endOf('year').format(Constants.DATE_FORMATS['YYYY-MM-DD']);
};

export const parseDateToIsoDay = (dateString: string): string => {
  const monthYear = moment(dateString, Constants.DATE_FORMATS['MM.YYYY'], true);
  return getRuFormattedDate(monthYear.startOf('month'), Constants.DATE_FORMATS['YYYY-MM-DD']);
};

export const getDateRangeForYear = (year: string): { startDate: string; endDate: string } => {
  const currentYear = String(getCurrentYear());
  const startDate = `${year}-01-01`;
  const endDate = year === currentYear ? getCurrentDate() : `${year}-12-31`;
  return { startDate, endDate };
};
